import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Form, Button, Card, Alert } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaUser, FaLock } from "react-icons/fa";
import { getUsuario } from "../../redux/actions";
import "../Login/login.css";
import logo from "../Login/Lisc.png";

const Login = () => {
  const [cedula, setCedula] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const usuarioError = useSelector((state) => state.usuarioError);

  useEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await dispatch(getUsuario(cedula, contrasena));
      if (response?.payload?.token) navigate("/home");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="login-container">
      <Card className="login-card">
        <div className="logo-container">
          <img src={logo} alt="SIISC Logo" className="logo-img" />
          <h1 className="login-title">SIISC</h1>
          <p className="login-subtitle">Sistema Integrado Incolab Services Colombia</p>
        </div>

        {usuarioError && (
          <Alert variant="danger" className="mb-4 text-center">
            {usuarioError}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label className="form-label-custom">Usuario</Form.Label>
            <div className="input-container">
              <FaUser className="input-icon" />
              <Form.Control
                className="custom-input"
                value={cedula}
                onChange={(e) => setCedula(e.target.value)}
                placeholder="Introduzca su identificación"
                required
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="form-label-custom">Contraseña</Form.Label>
            <div className="input-container">
              <FaLock className="input-icon" />
              <Form.Control
                type={showPassword ? "text" : "password"}
                className="custom-input"
                value={contrasena}
                onChange={(e) => setContrasena(e.target.value)}
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </Form.Group>

          <Button
            className="custom-button w-100"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            ) : null}
            {loading ? "Iniciando sesión..." : "Acceder al sistema"}
          </Button>
        </Form>

        <div className="text-center mt-4">
          <a href="/recuperar" className="custom-link">¿Olvidó su contraseña?</a>
        </div>

        <div className="login-footer text-center mt-3">
          <span className="custom-version">
            Versión 2.3.1 | Actualización: 2026-02-27
          </span>
        </div>
      </Card>

      <div className="global-footer">
        © 2026 Incolab Services Colombia | Equipo de Gestión TI
      </div>
    </Container>
  );
};

export default Login;
